/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';

import { DetailsListComponent } from './components/details-list/details-list.component';
import { InputDetailsListComponent } from './components/input-details-list/input-details-list.component';
import { SimpleDetailsComponent } from './components/simple-details/simple-details.component';
import { SharedModule } from 'app/shared/shared.module';
import { SelectionListComponent } from './components/selection-list/selection-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedConfigEditorComponent } from './components/shared-config-editor/shared-config-editor.component';
import { LegacyMultiSelectModule } from '@opengamma/ui';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MonacoEditorModule } from 'ngx-monaco-editor';

@NgModule({
  declarations: [
    DetailsListComponent,
    InputDetailsListComponent,
    SelectionListComponent,
    SimpleDetailsComponent,
    SharedConfigEditorComponent
  ],
  imports: [
    FormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatButtonModule,
    MatTooltipModule,
    SharedModule,
    LegacyMultiSelectModule,
    MatTabsModule,
    MonacoEditorModule
  ],
  exports: [
    DetailsListComponent,
    InputDetailsListComponent,
    SelectionListComponent,
    SimpleDetailsComponent,
    SharedConfigEditorComponent
  ]
})
export class TenantManagementCommonModule {}
